import {AfterViewInit, Directive, ElementRef, HostListener, Input} from '@angular/core';

declare let h337: any;

@Directive({
  selector: '[libHeatmap]'
})


export class HeatmapDirective implements AfterViewInit{

  @Input() config: {
    width: number,
    height: number
  } = {
    width: 0,
    height: 0
  };
  @Input() index: any;
  @Input() max: any;
  @Input() coordinates: Array<{ x: number, y: number, duration: number, value?: number }> = [];


  heatMap: any;
  heatmapConfig: any;
  data: any = {
    data: [],
    max: 1,
    min: 0
  };

  animationInterval: any;

  addedPoints = 0;

  @HostListener('mouseover') onMouseOver() {
    this.startAnimation();
  }

  @HostListener('mouseout') onMouseOut() {
    this.stopAnimation();
  }
  constructor(
    private elementRef: ElementRef
  ) {
  }

  startAnimation() {
    this.data.data = [];
    this.heatMap.setData(this.data);
    const timeout = 1500 / this.coordinates.length;
    this.animationInterval = setInterval(() => {
      const nextEl = this.coordinates[this.addedPoints];
      this.addedPoints++;

      if (this.coordinates.length === this.addedPoints - 1) {
        // this.data.data = []
        // this.heatMap.setData(this.data);
        this.stopAnimation();
      } else {
        this.heatMap.addData(nextEl);
      }
    }, timeout);
  }

  stopAnimation() {
    this.addedPoints = 0;
    if (typeof this.animationInterval !== 'undefined') {
      clearInterval(this.animationInterval);
    }
    this.data = {
      data: this.coordinates,
      max: 1, // Math.max.apply(null, this.coordinates.map(el => el.duration)),
      min: 0 //  Math.min.apply(null, this.coordinates.map(el => el.duration))
    };
    this.heatMap.setData(this.data);
  }

  ngAfterViewInit() {
    this.heatmapConfig = {
      container: this.elementRef.nativeElement,
      opacity: .48,
      radius: 22,
      minOpacity: .3,
      blur: .4
    };
    this.coordinates = this.coordinates.map(el => {
      const {x, y, duration} = el;
      return {x: Math.round(this.config.width * x), y: Math.round(this.config.height * y), value: 1, duration};
    });

    this.heatMap = h337.create(this.heatmapConfig); // creating the instance
    this.stopAnimation();
  }
}
